;(function () {
    // object-fit fallback for IE 11
    var ua = navigator.userAgent;
    var isIE10 = ua.match(/MSIE 10.0/i);
    var isIE11 = ua.match(/rv:11.0/i);

    if (isIE10 || isIE11) {
        // instead of the object-fit image we just set the src as background
        $('div.fullscreen-image').each(function () {
            var img = $(this).find('img.fullscreen-image, picture.fullscreen-image img');
            var imgSrc = img.attr('src');
            if (!imgSrc) {
                return;
            }
            img.remove();
            $(this).css('background-image', 'url(' + imgSrc + ')');
            $(this).css('background-position', 'center');
            $(this).css('background-size', '100%');
        });
    }
}());
